import { getLinks } from "@ingka-group-digital/opp-components";
export const getAccessibleApps = (currentApp, isVersion2, env = "dev") => {
    const res = getLinks(env);
    const resp = res
        .filter((app) => app.label !== currentApp)
        .filter((app) => !(env === "prod" && app.label === "Hours budgeting"))
        .filter((app) => app.version === (isVersion2 ? 2 : 1));
    return resp;
};
export const getOppURL = (isProd = true) => isProd
    ? "https://peopleplanning.ingka.com"
    : "https://stage.peopleplanning.ingkadt.com/";
//# sourceMappingURL=getAccessibleApps.js.map